import { Box, FormControl, styled } from '@mui/material';

export const StyledSelectsWrapper = styled(Box)({
    margin: '8px',
    order: 1,
    display: 'flex',
    flexWrap: 'wrap',
});

export const StyledFormControl = styled(FormControl)({
    width: '260px',
    padding: '8px',
    marginBottom: '8px',
    flexGrow: 1,
    '@media (max-width: 1540px)': {
        width: '50%',
    },
    '@media (max-width: 580px)': {
        width: '100%',
    },
    '& .MuiFormLabel-root.MuiInputLabel-root': {
        top: '10px',
    },
});

export const TableFiltersFormControl = styled(FormControl)({
    width: '260px',
    padding: '8px',
    marginBottom: '8px',
    flexGrow: 1,
    '@media (max-width: 1540px)': {
        width: '50%',
    },
    '@media (max-width: 580px)': {
        width: '100%',
    },
});
